import { useState, useRef } from 'react'

export default function useComponentVisible() {
  const [isComponentVisible, setIsComponentVisible] = useState(false)
  const ref = useRef(null)
 
  return { ref, isComponentVisible, setIsComponentVisible }
}
